module.exports = __webpack_public_path__ + "media/images/elionline/logo-aeabdd6f8282fd5e5c2c1b7473b2313e.svg";